import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import {skip} from 'rxjs/operators';
import {ValueLists} from '@common/core/services/value-lists.service';
import {DatatableService} from '@common/datatable/datatable.service';
import {LinkUsageService} from '../../shared/link/link-usage.service';
import {Subscription} from 'rxjs';
import {Settings} from '@common/core/config/settings.service';
import {NotificationService} from '@common/notifications/notification-list/notification.service';
import {WorkspacesService} from '@common/workspaces/workspaces.service';
import {SidenavComponent} from '@common/shared/sidenav/sidenav.component';

interface DatatableComponent {
    datatable?: DatatableService<any>;
}

@Component({
    selector: 'dashboard-host',
    templateUrl: './dashboard-host.component.html',
    styleUrls: ['./dashboard-host.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ValueLists],
})
export class DashboardHostComponent implements OnInit, OnDestroy {
    @ViewChild(SidenavComponent, {static: true}) sidenav: SidenavComponent;
    private activePage: DatatableComponent;
    private subscriptions: Subscription[] = [];

    constructor(
        private linkUsage: LinkUsageService,
        public settings: Settings,
        private notifications: NotificationService,
        private workspaces: WorkspacesService,
    ) {}

    ngOnInit() {
        this.bindToNotificationClick();
        this.bindToWorkspaceChange();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        this.subscriptions = [];
    }

    onPageChange(component: DatatableComponent) {
        this.activePage = component;
    }

    private bindToWorkspaceChange() {
        const sub = this.workspaces.activeId$
            .pipe(skip(1))
            .subscribe(() => {
                this.activePage.datatable?.reset();
                this.linkUsage.reload();
            });
        this.subscriptions.push(sub);
    }

    private bindToNotificationClick() {
        const sub = this.workspaces.bindToNotificationClick();
        this.subscriptions.push(sub);
    }
}
